/**
 * PaperTexture - SVG overlay for tactile paper feel
 *
 * Uses feTurbulence filter to create a subtle paper grain texture
 * that overlays the entire app. This creates the "physical notebook" aesthetic.
 */

export function PaperTexture() {
  return (
    <svg className="paper-texture-overlay" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="paper" x="0%" y="0%" width="100%" height="100%">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.04"
            numOctaves={5}
            result="noise"
          />
          <feDiffuseLighting
            in="noise"
            lightingColor="#fffcf5"
            surfaceScale={2}
            result="lit"
          >
            <feDistantLight azimuth={45} elevation={60} />
          </feDiffuseLighting>
        </filter>
      </defs>
      <rect width="100%" height="100%" filter="url(#paper)" />
    </svg>
  )
}
